<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-mouse`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36 11a9 9 0 00-17.802-1.885C11.319 9.999 6 15.878 6 23v9c0 7.732 6.268 14 14 14s14-6.268 14-14v-9c0-6.936-5.044-12.694-11.664-13.806A5.002 5.002 0 0132 11a7 7 0 007 7h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2l-.176-.005A3 3 0 0136 11zM20 42c-5.523 0-10-4.477-10-10h20c0 5.523-4.477 10-10 10zm0-29c-5.523 0-10 4.477-10 10v4.999h20V23c0-5.523-4.477-10-10-10zm2 5a1 1 0 00-1-1h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5z"/></svg>
</template>
<script>

export default {
  name: 'IconMouse',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
